import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import LogicContext from "../../Context/LogicContext";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
// import SelectSelect from "./StatusSelect";
import { FileUploader } from "react-drag-drop-files";
import { settingsService } from "../../services/settingsService";
import moment from "moment";
import { GetEditAdsStore, SetEditAdsStore } from "../../store/AddsStoreAtom";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import { FEATURE_HEIGHT } from "../../helpers/constantsFile";
// import FeatureSelect from "./FeatureSelect";
import imageCompression from 'browser-image-compression';







function NewAdsPage() {
    const navigate = useNavigate();
    const myPromiseModal = createModal(GeneralModal);
    const { register, setValue, getValues, handleSubmit, control, reset, formState: { errors } } = useForm();
    const logicContext = useContext(LogicContext);

    const setEditAds = SetEditAdsStore();
    const getEditAds = GetEditAdsStore();
    const [file, setFile] = useState(null);
    const [imageSource, setImageSource] = useState(null);
    const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];
   



    useEffect(() => {
      let isMounted = true;

      if (isMounted) {
        setValue('ref_no', 0);

        if (getEditAds?.Ref_No) {
          setValue('ad_title', getEditAds.Ad_Title);
          setValue('ad_title', getEditAds.Ad_Description);
          setValue('ad_description', getEditAds.Ad_Description);
          setValue('ad_image_url', getEditAds.Ad_Image_URL);
          setValue('ad_start_date', getEditAds.Ad_Image_URL);
          setValue('ad_end_date', getEditAds.Ad_End_Date);
          setValue('app_action_page', getEditAds.App_Action_Page);
          setValue('web_action_page', getEditAds.Web_Action_Page);
          setValue('ad_status_id', getEditAds?.Ad_Status_Id);

          setImageSource(getEditAds.Ad_Image_URL);
        }
      }

      return () => {
        isMounted = false;
        setEditAds({});
      };
    }, [getEditAds?.Ref_No]);


    function startDateFunction() {
        let defaultDate = moment(Date.now()).format("YYYY-MM-DD");
        if (getEditAds?.Ad_Start_Date !== undefined) {
            defaultDate = moment(getEditAds?.Ad_Start_Date).format("YYYY-MM-DD");
        }

        return (
            <>
             <span className="text-sm text-filterTextColor font-bold">
                                        Start Date:
                 </span>
                     <br />
                <input
                    className="bg-inputColor h-[6vh] pl-3  w-[35vw] "
                    placeholder="enter start date"  type="date"
                    defaultValue={defaultDate}
                    {...register("ad_start_date", {
                        required: "Start date is required",
                    })}
                />
            </>

        )
    }



    function endDateFunction() {
        let defaultDate = moment(Date.now()).format("YYYY-MM-DD")
        if (getEditAds?.Ad_End_Date !== undefined) {
            defaultDate = moment(getEditAds?.Ad_End_Date).format("YYYY-MM-DD")
        }

        return (
            <>
             <span className="text-sm text-filterTextColor font-bold">
                    End Date:
                </span>
                <br />
                <input
                    className="bg-inputColor h-[6vh] pl-3  w-[35vw] "
                    placeholder="enter end date" type="date"
                    defaultValue={defaultDate}
                    {...register("ad_end_date", {
                        required: "End date is required",
                    })}
                />
                <br />


            </>

        )
    }

    const onSubmit = async () => {
        const formValues = getValues();
        if (!imageSource) {
            return logicContext.showToast('Please add image', 'error');
        }

        //  Start edit
        if (getEditAds?.Ref_No) {
            await myPromiseModal({ title: "Update record!", body: `Please confirm your action.`,
                showInput: false, placeHolder: ''   }).then((res) => {
                if (res.decision === true) {
                    const formData = new FormData();
               


                    formData.append('file', file);
                 
                    var formObject = JSON.stringify({ ...formValues, ref_no: getEditAds?.Ref_No });
                    formData.append('formObject', formObject);
                    settingsService.updateExistingAds(formData).then(res => {
                      const serverRes = toLowercaseKeys(res.data);
                      const cleanResponse = logicContext.httpResponseManager(serverRes?.[0] || serverRes?.result_status?.[0]);

                      const { message_id, message_text } = cleanResponse;
                      if (message_id == 1) {
                        logicContext.showToast(message_text, 'success');
                        reset();
                        sessionStorage.setItem('reloadPage', 'true');
                        navigate(-1);
                      }
                    });
                }
            });

            // end Edit
        } else {

            //  New record
            await myPromiseModal({
                title: "Save record!", body: `Please confirm your action.`, showInput: false, placeHolder: '' }).then((res) => {
                if (res.decision === true) {

                    const formData = new FormData();
                 
                    formData.append('file', file);
                    var formObject = JSON.stringify(formValues);
                    formData.append('formObject', formObject);
                    for (const [key, value] of formData.entries()) {
                      }
                    settingsService.submitNewAds(formData).then(res => {
                    
                        const serverRes =  toLowercaseKeys(res.data);
                           const cleanResponse = logicContext.httpResponseManager(serverRes?.[0] || serverRes?.result_status?.[0]);

                           const { message_id, message_text } = cleanResponse;
                           if (message_id == 1) {
                             logicContext.showToast(message_text, 'success');
                             reset();
                             sessionStorage.setItem('reloadPage', 'true');
                            navigate(-1);

                           }
                    });
                }
            });

            // end new record

        }



    }


    function formError(error) {
        console.log('errr ', error);
        logicContext.showToast("Form error", "error");
    }


    const onImageLoad = (event) => {
        const imageWidth = event?.target?.naturalWidth;
        const imageHeight = event?.target?.naturalHeight;
        // setTempHeight(imageHeight);
        // setTempWidth(imageWidth);
        // if (imageHeight !== BASE_HEIGHT){
        //   return logicContext.showToast(`Image height of ${imageHeight}h is unacceptable. Image width and height must be ${BASE_HEIGHT}h and ${BASE_WIDTH}w`, 'error');
        // }else if(imageWidth !== BASE_WIDTH){
        //   return logicContext.showToast(`Image width of ${imageWidth}w is unacceptable. Image width and height must be ${BASE_HEIGHT}h and ${BASE_WIDTH}w`, 'error');
        // }
    }




      const handleImageChange = async imageFile => {
        if (!imageFile) return;
    
        let imageUrl = null;
    
        try {
          const img = new Image();
          imageUrl = URL.createObjectURL(imageFile);
    
          img.onload = async () => {
            try {
         
    
              // Compress the image
              const originalSizeMB = imageFile.size / 1024 / 1024;
    
              const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1024,
                useWebWorker: true,
                fileType: 'image/jpeg',
              };
    
               logicContext.showToast('Image compressing...', 'info');
              const compressedFile = await imageCompression(imageFile, options);
              setFile(compressedFile);
    
              const reader = new FileReader();
              reader.addEventListener('load', () => {
                setImageSource(reader.result);
              });
              reader.readAsDataURL(compressedFile);
    
              const compressedSizeMB = compressedFile.size / 1024 / 1024;
              logicContext.showToast(`Image optimized: ${originalSizeMB.toFixed(2)}MB → ${compressedSizeMB.toFixed(2)}MB`, 'success');
            } finally {
              URL.revokeObjectURL(imageUrl);
            }
          };
    
          img.onerror = () => {
            URL.revokeObjectURL(imageUrl);
            logicContext.showToast('Failed to load image', 'error');
          };
    
          img.src = imageUrl;
        } catch (error) {
          // Clean up blob URL if error occurs
          if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
          }
          logicContext.showToast('Failed to process image', 'error');
          console.error('Compression error:', error);
        }
      };




    return (
      <>
        <div className="jumbotron bg-light">
          <div className="row">
            <div className="col">
              <h6 class="text-lg mb-3 font-bold"> New Ads</h6>
            </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit, formError)}>
            <section className="">
              <div className="row">
                <div className="col-6">
                  <div className="container">
                    <span className="text-sm text-filterTextColor font-bold ">Ads title:</span>
                    <br />
                    <input
                      className="bg-inputColor h-[6vh] pl-3  w-[35vw]"
                      placeholder="Enter ads title"
                      type="text"
                      name="feature_name"
                      {...register('ad_title', {
                        required: 'Ads title is required',
                      })}
                    />
                    <br />
                    <small className="text-red-500">{Boolean(errors['ad_title']?.message) && String(errors['ad_title']?.message)}</small>
                  </div>

                  <div className="container">
                    <span className="text-sm text-filterTextColor font-bold ">Description:</span>
                    <br />
                    <input
                      className="bg-inputColor h-[6vh] pl-3  w-[35vw]"
                      placeholder="Enter description"
                      type="text"
                      name="feature_name"
                      {...register('ad_description', {
                        required: 'Ads description is required',
                      })}
                    />
                    <br />
                    <small className="text-red-500">
                      {Boolean(errors['ad_description']?.message) && String(errors['ad_description']?.message)}
                    </small>
                  </div>

                  <div className="container">{startDateFunction()}</div>

                  <div className="container">{endDateFunction()}</div>
                  <div className="container">
                    <span className="text-sm text-filterTextColor font-bold">Mobile action page:</span>
                    <br />
                    <input
                      className="bg-inputColor h-[6vh] pl-3  w-[35vw] "
                      placeholder="Enter mobile action page"
                      type="text"
                      name="slide_order"
                      {...register('app_action_page', {
                        required: 'Slide order is required',
                      })}
                    />
                    <br />
                    <small className="text-red-500">
                      {Boolean(errors['app_action_page']?.message) && String(errors['app_action_page']?.message)}
                    </small>
                  </div>

                  <div className="container">
                    <span className="text-sm text-filterTextColor font-bold">Web action page:</span>
                    <br />
                    <input
                      className="bg-inputColor h-[6vh] pl-3  w-[35vw] "
                      placeholder="Enter web action page"
                      type="text"
                      name="slide_order"
                      {...register('web_action_page', {
                        required: 'Slide order is required',
                      })}
                    />
                    <br />
                    <small className="text-red-500">
                      {Boolean(errors['web_action_page']?.message) && String(errors['web_action_page']?.message)}
                    </small>
                  </div>

                  <div className="container">
                    <span className="text-sm text-filterTextColor font-bold">Button text:</span>
                    <br />
                    <input
                      className="bg-inputColor h-[6vh] pl-3  w-[35vw] "
                      placeholder="Enter button text"
                      type="text"
                      name="ad_button_text"
                      {...register('ad_button_text', {
                        required: 'Button text is required',
                      })}
                    />
                    <br />
                    <small className="text-red-500">
                      {Boolean(errors['ad_button_text']?.message) && String(errors['ad_button_text']?.message)}
                    </small>
                  </div>
                </div>

                <div className="col-6">
                  {/* Image Upload Section */}
                  <div className="flex flex-col items-center space-y-4 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
                    {/* Upload Area */}
                    <div className="w-full max-w-sm">
                      <FileUploader
                        className="uploader border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-400 transition-colors cursor-pointer bg-gray-50"
                        id="uploader"
                        minSize={0.1}
                        maxSize={3}
                        handleChange={handleImageChange}
                        name="file"
                        types={fileTypes}
                        multiple={false}
                      >
                        <div className="flex flex-col items-center space-y-2">
                          <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          <p className="text-sm font-medium text-gray-700">Drop your image here or click to browse</p>
                          <p className="text-xs text-gray-500">Supports JPG, PNG (max 3MB)</p>
                        </div>
                      </FileUploader>
                    </div>

                    {/* Preview */}
                    {imageSource && (
                      <div className="flex justify-center">
                        <div className="relative">
                          <img
                            className="rounded-full border-4 border-gray-200 shadow-lg object-cover"
                            onLoad={e => onImageLoad(e)}
                            src={imageSource}
                            alt="Preview"
                            style={{ width: '200px', height: '200px' }}
                          />
                          <button
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 transition-colors"
                            onClick={() => handleImageChange({ target: { files: [] } })} // Assuming you have a way to clear
                            type="button"
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    )}
                    {!imageSource && (
                      <div className="w-48 h-48 rounded-full bg-gray-100 flex items-center justify-center border-2 border-dashed border-gray-300">
                        <p className="text-gray-500 text-sm">No image selected</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className=" flex justify-end ">
                <button type="submit" className="rounded-lg px-10  hover:bg-sky-700  my-3 py-2 bg-blue-500 text-blue-100">
                  Submit
                </button>
              </div>
            </section>
          </form>
        </div>
      </>
    );
}

export default NewAdsPage;





